import { ConfigProvider, Layout, Tabs } from "antd";
import { storage } from "lib";
import { useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";

import {
  BankOutlined,
  FileOutlined,
  PartitionOutlined,
  TeamOutlined,
  UserOutlined
} from "@ant-design/icons";
import { Content, Header } from "antd/es/layout/layout";
import MyTabsMenu from "components/elements/MyTabs/MyTabsMenu";
import { useSelector } from "react-redux";
import { COMPANY_PAGE, COMPANY_PAGE_LIST } from "../schemas/companySchema";
import styles from "../styles/CompanyMenu.module.css";
import "./CompanyMenuCss.css";


// const COMPANY_SETTING_MENU = [
//   getItem("company_profile", "Company Profile", "profile", <BankOutlined />),
//   getItem("organization", "Organization", "organization", <TeamOutlined />),
//   getItem("position", "Position", "position", <TeamOutlined />),
//   getItem("condition", "Condition", "condition", <UserOutlined />, [
//     getItem("working_condition", "Working Condition", "condition.working"),
//     getItem("overtime_condition", "Overtime Condition", "condition.overtime"),
//   ]),
//   getItem("branch", "Branch List", "branch_list", <PartitionOutlined />),
//   getItem("document", "Document", "document", <FileOutlined />),
// ];

const CompanyMenu = ({ setMenu, pageType, className = "", onChange = () => { }, children }) => {
  const [selectedKeys, setSelectedKeys] = useState(["profile"]);
  const [collapsed, setCollapsed] = useState(false);
  const { t } = useTranslation();
  const { roles } = useSelector((state) => state.company);
  function getItem(rules, label, key, icons) {
    let list = [...roles]
    if (!list.includes(rules)) {
      return {}
    }
    return {
      label: label,
      key: key,
      icons: icons
    };
  }
  const MENU = [
    getItem("ACCESS_CONFIGURATION|COMPANY_SETTING|COMPANY_PROFILE", t('company_profile.header'), "profile"),
    getItem("ACCESS_CONFIGURATION|COMPANY_SETTING|ORGANIZATION", t('organization.header'), "organization"),
    getItem("ACCESS_CONFIGURATION|COMPANY_SETTING|POSITION", t('position.header'), "position"),
    getItem("ACCESS_CONFIGURATION|COMPANY_SETTING|CONDITION", t('condition.header'), "condition"),
    getItem("ACCESS_CONFIGURATION|COMPANY_SETTING|BRANCH", t('branch.header'), "branch_list"),
    getItem("ACCESS_CONFIGURATION|COMPANY_SETTING|DOCUMENT", t('document.header'), "document"),
    getItem("ACCESS_CONFIGURATION|COMPANY_SETTING|THEME", t("appearance.header"), "appearance"),
  ];

  const onMenuClick = (e) => {
    const key = e;
    setSelectedKeys([key]);
    onChange(key);
    // storage.sessionStorage.setItem("config.menu", key);
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  };

  useEffect(() => {
    setSelectedKeys([MENU.filter(o => o?.key != null)?.[0]?.key]);
    setMenu(MENU.filter(o => o?.key != null)?.[0]?.key)
  }, []);

  useMemo(() => {
    // let keyOne = MENU.filter(o => o?.key != null)
    // console.log("MENU", keyOne);
    if (MENU.filter(o => o?.key != null)?.[0]?.key) {
      setMenu(MENU.filter(o => o?.key != null)?.[0]?.key)
      setSelectedKeys([MENU.filter(o => o?.key != null)?.[0]?.key])
    }
  }, [MENU.filter(o => o?.key != null)?.[0]?.key])

  return (
    <Layout
      // className={cx(
      //   // styles.container,
      // )}
      style={{
        backgroundColor: 'transparent'
      }}
      hasSider={false}
    >
      <Header style={{
        padding: 0,
        backgroundColor: 'transparent'
      }}>
        <ConfigProvider
          theme={{
            components: {
              Tabs: {
                itemHoverColor: "var(--tab-color)",
                itemActiveColor: "var(--tab-color)"
              },
            },
          }}
        >
          <Tabs items={MENU} onChange={onMenuClick} defaultValue={MENU.filter(o => o?.key != null)?.[0]?.key} activeKey={selectedKeys[0]}
            defaultActiveKey={"profile"} />
        </ConfigProvider>
      </Header>
      <Content
        className={styles.content}
        style={{
          // margin: '8px 8px',
          // padding: 10,
          // backgroundColor: "#f1f7fd",
          borderRadius: 0,
        }}
      >
        <div style={{
          // margin: '8px 8px',
          // padding: 10,
          minHeight: "30vh",
          minWidth: "30vh",
          // background: "red",
          // maxWidth: "10000vh",
          // padding: "10px",
          width: "100%",
          // overflow: "hidden"
          // backgroundColor: "#f1f7fd",
          // borderRadius: 0,
        }}>
          {children}</div>
      </Content>
      {/* <Footer></Footer> */}
    </Layout>
  );

};

export default CompanyMenu;
